const methods = {
    1: "POST",
    2: "GET",
    3: "PUT",
    4: "DELETE",
}

export const getMethodNameHTTP = (number) => {
    return methods[number] ?? ""
}